import React from 'react';
import { Key } from 'lucide-react';
import { DrawerCallout } from '../../shared/activity-drawer/ui/DrawerCallout';

export interface CredentialsCalloutProps {
  password: string;
  onCopy(): void;
}

// Callout "Salva queste credenziali" con la password appena generata, condiviso fra
// PartnerPortalAccessDetails e ProjectsPortalAccessDetails (era markup identico duplicato
// nei due file).
export function CredentialsCallout({ password, onCopy }: CredentialsCalloutProps): JSX.Element {
  return (
    <DrawerCallout tone="warning">
      <span className="font-semibold">Salva queste credenziali</span>
      <div className="mt-0.5">La password non sarà più visibile dopo la chiusura del drawer.</div>
      <div className="mt-1.5 flex items-center gap-2 font-mono text-[11px]">
        <Key className="h-3 w-3 shrink-0" strokeWidth={1.5} />
        {password}
        <button
          type="button"
          onClick={onCopy}
          className="ml-auto text-[11px] font-medium text-[#787774] dark:text-gray-400 hover:text-[#37352F] dark:hover:text-white px-1.5 py-0.5 rounded hover:bg-[rgba(55,53,47,0.08)] dark:hover:bg-white/[0.06]"
        >
          Copia
        </button>
      </div>
    </DrawerCallout>
  );
}
